const selectItemReducer = (data = "unset", action) => {
    switch(action.type){
        case 'SELECT_ITEM':
            data = action.data
            return data;
        default:
            return data;
    }
}

export default selectItemReducer;